import { Text, TextProps } from '@chakra-ui/react';
import { rem } from 'polished';
import { PropsWithChildren } from 'react';

export const ProminentButtonLabel = ({
  display,
  px,
  paddingX,
  ...textProps
}: PropsWithChildren<TextProps>) => (
  <Text
    as="span"
    px={px || paddingX || 'space.32'}
    display={display || 'block'}
    color="white"
    fontSize="lg"
    fontWeight="medium"
    letterSpacing="-0.03em"
    textAlign="center"
    lineHeight={rem(42)}
    whiteSpace="nowrap"
    overflow="hidden"
    textOverflow="ellipsis"
    {...textProps}
  />
);
